import validate from 'validate.js';

import map from 'lodash/map';
import last from 'lodash/last';
import reduce from 'lodash/reduce';
import compact from 'lodash/compact';
import upperFirst from 'lodash/upperFirst';

// Config validate.js
validate.validators.email.options = { message: 'is not a valid' };

// Custom validators
validate.validators.onlyLetters = function(value, options, key, attributes) {
  const regex = /^[a-z\s]+$/i;

  if (!regex.test(value)) {
    return 'can contain only letters';
  }
}

validate.validators.onlyLettersAndNumbers = function(value, options, key, attributes) {
  const regex = /^[a-z0-9\s]+$/i;

  if (!regex.test(value)) {
    return 'can contain only letters and numbers';
  }
}

// Constants
const REGEX_NAME = /\w+.?\[(.*?)\]/g;

// Validation for Rails forms
class FormValidation {
  constructor(formSelector, constraints) {
    this.form        = document.querySelectorAll(formSelector);
    this.constraints = constraints;

    if (this.form.length > 0) {
      this.addEvenets();
    }
  }

  addEvenets() {
    $(this.form)
      .on('ajax:beforeSend', this.ajaxBefore.bind(this))
      .on('ajax:error', this.ajaxError.bind(this))
  }

  setUIErrors(form, errors) {
    this.errors = this.prettifyErrors(errors || {});
    this.showUIErrors(form);
  }

  setBackendErrors(form, error=null) {
    const errors = error ? { backend: [error] } : this.errors;
    this.backendError = compact(map(errors, (messages) => messages.join('<br>') )).join('<br>')
    this.showBackendErrors(form);
  }

  ajaxBefore(e) {
    const form = e.target;
    const errors = validate(form, this.constraints, { fullMessages: false });
    this.setUIErrors(form, errors);
    return validate.isEmpty(errors)
  }

  ajaxError({ target, detail: [data, _error, xhr] }) {
    const { error, errors } = data || {};

    if (error) {
      this.setBackendErrors(target, error);
    }

    if (xhr && xhr.status == 413) {
      this.setBackendErrors(target, 'File is too large');
    }

    if (errors) {
      this.setUIErrors(target, errors);
    }
  }

  showUIErrors(form) {
    const inputs = form.querySelectorAll('input[name]');

    this.removeBackendError(form);

    map(inputs, (input) => this.showErrorsForInput(input))

    this.setBackendErrors(form);
  }

  showBackendErrors(form) {
    this.removeBackendError(form);

    if (this.backendError) {
      $(form.commit).after(`<p class="backend-error error">${this.backendError}</p>`);
    }
  }

  showErrorsForInput(input) {
    const $formGroup = $(input).closest('.form-group');
    const name       = this.regexName(input.name);

    this.resetFormGroup($formGroup);

    if (this.errors[name]) {
      this.addErrors($formGroup, this.errors[name]);
      if ($(input).is(':visible')) this.errors[name] = []
    }
  }

  resetFormGroup($formGroup) {
    $formGroup.removeClass('has-error').find('.error').remove();
  }

  addErrors($formGroup, errors) {
    $formGroup.addClass('has-error');
    // NOTE: if need show many errors
    // map(errors, (error) => $formGroup.append(`<p class="error">${upperFirst(error)}</p>`))
    $formGroup.append(`<p class="error">${upperFirst(last(errors))}</p>`)
  }

  removeBackendError(form) {
    $(form).find('.backend-error').remove();
  }

  prettifyErrors(errors) {
    return reduce(errors, (result, messages, name) => {
      name = this.regexName(name);

      result[name] = map(messages, (message) => {
        message = this.regexName(message);
        return upperFirst(`${name} ${message}`)
      });

      return result;
    }, {});
  }

  regexName(str) {
    return str.replace(REGEX_NAME, '$1').replace(/_/g, ' ');
  }
}

export default FormValidation;



// WEBPACK FOOTER //
// app/javascript/common/form-validation.js